import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HsnList from "./HsnList";
import { getHsnList } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  hsnData: state.businessItemReducer.hsnList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getHsnList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HsnList);